import { render } from "./EpicItem.vue?vue&type=template&id=3aa9d4cc&scoped=true"
import script from "./EpicItem.vue?vue&type=script&lang=js"
export * from "./EpicItem.vue?vue&type=script&lang=js"

import "./EpicItem.vue?vue&type=style&index=0&id=3aa9d4cc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa9d4cc"]])

export default __exports__